// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 907) return "css/907-676d8860.css";
	if (chunkId === 474) return "css/474-8f3ca82a.css";
	if (chunkId === 774) return "css/774-a92c265e.css";
	// return url for filenames based on template
	return "css/" + {"67":"academics","165":"zeit_jobs","740":"print","936":"fused","964":"style_guide"}[chunkId] + "-" + {"67":"f23ae777","165":"e6cb379d","740":"50609a88","936":"be5b0127","964":"ab611c49"}[chunkId] + ".css";
};